module.exports = __webpack_public_path__ + "img/background.10403715.png";